import { DataWarehouseConnection } from '../workflow/connections/index'
import { FilterWorkflowComponent } from './common/filtercomponent'
import { Provider, TableSchema, WorkflowCodeType, WorkflowComponentParamType, WorkflowEnvVars } from '../types'
import { Workflow } from '../workflow'
import dedent from 'ts-dedent'

class TableFilter extends FilterWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.where',
        group: 'Data Preparation',
        title: 'Where',
        description: `
      This component filters an input table according to a WHERE expression.
      `,
        starred: true
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'expression',
          type: WorkflowComponentParamType.StringSql,
          title: 'Filter expression',
          placeholder: 'E.g.: area > 1000 AND area < 3000'
        }
      ]
    )
    this.requiresDynamicSQL = true
  }

  async _getMatchCode(
    params: Record<string, unknown>,
    envVars: WorkflowEnvVars,
    workflow: Workflow,
    componentName: string,
    connection: DataWarehouseConnection,
    codeType: WorkflowCodeType,
    schema?: TableSchema
  ) {
    if (connection.type === Provider.DatabricksRest) {
      return dedent`SELECT /*+ REPARTITION(40) */
        *
      FROM ${connection.quoteName(params.source as string)}
      WHERE ${params.expression}`
    } else {
      return dedent`SELECT *
      FROM ${connection.quoteName(params.source as string)}
      WHERE ${params.expression}`
    }
  }

  async _getUnmatchCode(
    params: Record<string, unknown>,
    matchTablename: string,
    envVars: WorkflowEnvVars,
    workflow: Workflow,
    componentName: string,
    connection: DataWarehouseConnection,
    codeType: WorkflowCodeType,
    schema?: TableSchema
  ) {
    if (connection.type === Provider.DatabricksRest) {
      return dedent`SELECT /*+ REPARTITION(40) */
        *
      FROM ${connection.quoteName(params.source as string)}
      WHERE NOT ${params.expression}`
    } else {
      return dedent`SELECT *
      FROM ${connection.quoteName(params.source as string)}
      WHERE NOT ${params.expression}`
    }
  }
  supportedProviders(): Provider[] {
    return [
      Provider.BigQuery,
      Provider.Postgres,
      Provider.Redshift,
      Provider.Snowflake,
      Provider.DatabricksRest,
      Provider.Oracle
    ]
  }
}

export { TableFilter }
